import { FC, ReactNode, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { BeatLoader } from 'react-spinners';
import { usePlatformAdminOrganisationOverride } from '@/hooks/use-platform-admin-organisation-override';

type PlatformAdminOrganisationOverrideRouteWrapperProps = {
  children: ReactNode;
  fallback: string;
};

export const PlatformAdminOrganisationOverrideRouteWrapper: FC<
  PlatformAdminOrganisationOverrideRouteWrapperProps
> = ({ children, fallback }) => {
  const navigate = useNavigate();
  const {
    data: organisation,
    isFetching: isFetchingOrganisations,
    isUninitialized: isOrganisationsUninitialized,
  } = usePlatformAdminOrganisationOverride();
  const isLoadingOrganisation =
    isOrganisationsUninitialized || isFetchingOrganisations;

  const orgId = organisation?.id ?? -1;

  useEffect(() => {
    if (!isLoadingOrganisation && orgId < 0) {
      navigate(fallback);
    }
  }, [isLoadingOrganisation, orgId, fallback, navigate]);

  return (
    <>
      {orgId < 0 ? (
        <div className="flex h-full flex-col items-center justify-center">
          <BeatLoader />
        </div>
      ) : (
        children
      )}
    </>
  );
};
